<template>
  <div id="home">
    <!-- 头部 -->
    <div class="home-header">
      <!-- 中心部分 -->
      <div class="home-header-center">
        <!-- 左侧图标 -->
        <div class="home-icon-left">
          <img src="../../assets/home/sy_dh_logo.png" alt="" />
        </div>

        <!-- 导航条 -->
        <div class="Navigation-bar">
          <el-menu
            :default-active="activeIndex"
            :router="true"
            class="el-menu-demo"
            active-text-color="#ffba00"
            mode="horizontal"
          >
            <el-menu-item index="/homepages">首页</el-menu-item>
            <el-submenu index="/ProductSolution">
              <template slot="title">
                产品中心
                <i class="el-icon-caret-bottom"></i>
              </template>
              <el-menu-item
                v-for="(item, indexc) in routeList"
                :key="indexc"
                :index="item.routerurl"
                :style="{
                  color: activeIndex == item.routerurl ? '#ffba00' : '',
                }"
              >
                <img :src="imgUrl" alt="" />
                {{ item.names }}
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="/serviceProvision">服务提供</el-menu-item>
            <el-menu-item index="/development">开放平台</el-menu-item>
            <el-menu-item index="/customer">客户案例</el-menu-item>
            <el-menu-item index="/consultingService">资讯</el-menu-item>
            <el-menu-item index="/aboutusPages">关于我们</el-menu-item>
          </el-menu>
        </div>

        <div class="home-icon-right">
          <!-- 电话图标 -->
          <div class="home-sy_dh" style="margin: 5px 5px 0 0">
            <img src="../../assets/home/sy_dh_dh.png" alt="" />
          </div>
          <div class="home-hotline">咨询热线：400-1606-202</div>
        </div>
      </div>
    </div>

    <div>
      <router-view />
    </div>
    <!-- 底部 -->
    <div class="home-bottom">
      <div class="home-bottom-cneter">
        <!-- 三个盒子 -->
        <div class="home-centent">
          <div
            class="home-bottom-list"
            v-for="(item, index) in bottomList"
            :key="index"
          >
            <div class="home-bottom-img">
              <img :src="item.imgs" alt="" />
            </div>
            <div class="home-bottom-texts">
              {{ item.texts }}
            </div>
          </div>
        </div>

        <!-- 第一个下划线 -->
        <div class="bottom-line"></div>
        <div class="home-centents">
          <!-- 阳光 -->
          <div class="home-bottom-flexs">
            <div
              class="home-centens-icon"
              v-for="(item, index) in finelist"
              :key="index"
            >
              <img :src="item.imgs" alt="" />
              <div class="home-contens-text1">
                {{ item.text1 }}
              </div>
              <div class="home-contens-text2">
                {{ item.text2 }}
              </div>
            </div>
          </div>
          <!-- - 产品服务 - -->
          <div class="product-service-box">
            <div class="product-service">- 产品服务 -</div>
            <div
              class="product-service-sass"
              @click="Product('/ProductSolution', 0)"
            >
              书商一体化解决方案
            </div>

            <div class="product-service-sass" @click="Product('/product', 1)">
              阅点点 & 千悦福鲤
            </div>
            <div
              class="product-service-sass"
              @click="Product('/gisLighting', 2)"
            >
              GIS智慧照明解决方案
            </div>
          </div>
          <!-- -  联系我们 - -->
          <div class="product-contact-box">
            <div class="product-service">- 联系我们 -</div>
            <div class="product-service-sass">客服热线：400-1606-202</div>
            <div class="product-service-sass">
              地址：南京市南昌路40号长江科技园
            </div>
            <div class="product-service-sass">GIS智慧照明解决方案</div>
          </div>
          <!-- 二维码 -->
          <div class="home-bottom-code">
            <div class="home-weixin">- 官方微信 -</div>
            <img :src="imgUrlCode" />
          </div>
        </div>
        <!-- 第er个下划线 -->
        <div class="bottom-lines"></div>
        <!--亿合尤迅  -->
        <div class="home-yhyx-box">
          <img :src="imgUrlyhyx" alt="" />
          <div class="technical-support">
            <div class="">技术支持：南京亿合尤讯信息技术有限公司</div>
            <div class="home-smart">智慧业态 | 电商服务 | 线上线下</div>
          </div>
        </div>
        <div class="home-copyright">
          <span>© COPYRIGHT 2016. 南京亿合尤讯信息技术有限公司 版权所有 | </span
          ><span
            class="home-copyright-active"
            @click="
              copyFun('https://beian.miit.gov.cn/?sid=3CpFyW#/Integrated/index')
            "
            >苏ICP备12345678号-1</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      type1: "",
      type2: 0,
      routeList: [
        {
          routerurl: "/ProductSolution",
          names: "书商一体化解决方案",
        },
        {
          routerurl: "/product",
          names: "阅点点 & 千悦福鲤",
        },

        {
          routerurl: "/shortMessage",
          names: "短信服务平台",
        },
        {
          routerurl: "/gisLighting",
          names: "GIS智慧照明解决方案",
        },
      ],
      rouIndex: "",
      imgUrl: require("../../assets/home/sy_dh_zkx.png"),
      imgUrlCode: require("../../assets/home/sy_foot_er.png"),
      imgUrlyhyx: require("../../assets/home/sy_foot_logo.png"),
      bottomList: [
        {
          imgs: require("../../assets/home/sy_foot_b1.png"),
          texts: "快速对接 · 敏捷上线",
        },
        {
          imgs: require("../../assets/home/sy_foot_b2.png"),
          texts: "正品保证 · 品类丰富",
        },
        {
          imgs: require("../../assets/home/sy_foot_b3.png"),
          texts: "专业售后 · 全面服务",
        },
      ],
      finelist: [
        {
          imgs: require("../../assets/home/sy_foot_b4.png"),
          text1: "阳光",
          text2: "SUNSHINE",
        },
        {
          imgs: require("../../assets/home/sy_foot_b5.png"),
          text1: "效益",
          text2: "EFFICIENCY",
        },
        {
          imgs: require("../../assets/home/sy_foot_b6.png"),
          text1: "转型",
          text2: "TRANSFORMATION",
        },
      ],
    };
  },
  watch: {
    "$route.path"(newdate, olddate) {
      this.activeIndex = newdate;
    },
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },
  methods: {
    Product(urls, index) {
      this.activeIndex = this.routeList[index].routerurl;
      this.$router.push(urls);
    },
    copyFun(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
#home {
  width: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  .home-header {
    width: 100%;
    min-height: 88px;
    position: fixed;
    top: 0px;
    z-index: 9999;
    background-color: #fff;
    display: flex;

    .home-header-center {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .Navigation-bar {
        display: flex;
        margin-left: 20px;

        /deep/ .el-menu.el-menu--horizontal {
          border-bottom: none;
        }

        /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
          border-bottom: none;
          font-family: MicrosoftYaHei-Bold;
          font-size: 16px;
          color: #ffba00;
        }

        /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          letter-spacing: 0px;
          color: #333333;
        }

        /deep/ .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
          display: none;
        }

        /deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
          border-bottom: none;
        }

        /deep/ .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          letter-spacing: 0px;
          color: #ffba00;
        }

        /deep/ .el-submenu [class^="el-icon-"] {
          vertical-align: middle;
          margin: 0px 0px 6px 0;
          width: 24px;
          text-align: center;
          font-size: 18px;
        }

        /deep/ .el-menu--horizontal > .el-menu-item {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          letter-spacing: 0px;
          color: #333333;
          border-bottom: none;
        }

        /deep/ el-menu-item {
          position: fixed;
          top: 74px;
          left: 700px;
          z-index: 2002;
        }

        /deep/ .el-menu--horizontal .el-menu .el-menu-item {
          background-color: #fff;
          float: none;
          height: 36px;
          line-height: 36px;
          padding: 0 10px;
          color: red;
        }

        /deep/ .el-menu-item {
          font-size: 14px;
          color: pink;
          padding: 0 20px;
          cursor: pointer;
          transition: border-color 0.3s, background-color 0.3s, color 0.3s;
          box-sizing: border-box;
        }
      }

      .home-icon-right {
        width: 253px;
        height: 40px;
        background-color: #ffd800;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .home-phone {
          .home-hotline {
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
  }

  .home-bottom {
    width: 100%;
    background: #fff;
    z-index: 9999;

    .home-bottom-cneter {
      width: 1200px;
      margin: 0 auto;
      padding-top: 38px;

      .home-centent {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .home-bottom-list {
          display: flex;
          align-items: center;

          .home-bottom-texts {
            margin-left: 21px;
            font-size: 18px;
            color: #333333;
          }
        }
      }

      .home-centents {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .home-bottom-flexs {
          .home-centens-icon {
            display: flex;
            align-items: center;
            margin: 0 0 41px 0;

            .home-contens-text1 {
              margin: 0 17px 0 22px;
              font-size: 16px;
              color: #555555;
            }

            .home-contens-text2 {
              font-size: 14px;
              color: #777777;
              opacity: 0.8;
            }
          }
        }

        .product-service-box {
          .product-service {
            font-size: 16px;
            margin-bottom: 35px;
            color: #444444;
          }

          .product-service-sass {
            font-size: 14px;
            margin: 27px 0px 0 10px;
            color: #989898;
            cursor: pointer;
          }

          .product-service-sass:hover {
            margin: 27px 0px 0 10px;
            font-size: 14px;
            color: #444444;
            cursor: pointer;
          }
        }

        .product-contact-box {
          .product-service {
            font-size: 16px;
            margin-bottom: 35px;
            color: #444444;
          }

          .product-service-sass {
            font-size: 14px;
            margin: 27px 0px 0 10px;
            color: #989898;
            cursor: pointer;
          }
        }

        .home-bottom-code {
          margin-top: 20px;
        }

        .home-weixin {
          text-align: center;
          font-size: 16px;
          padding-bottom: 16px;
          color: #444444;
        }
      }

      .bottom-line {
        width: 1200px;
        height: 1px;
        margin: 40px 0 25px 0;
        background-color: #ebeff2;
      }

      .bottom-lines {
        width: 1200px;
        height: 1px;
        margin: 0 0 25px 0;
        background-color: #ebeff2;
      }

      .home-yhyx-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 32px;

        .technical-support {
          margin-left: 16px;
          font-size: 12px;
          color: #aaaaaa;
          opacity: 0.7;

          .home-smart {
            margin-top: 7px;
          }
        }
      }

      .home-copyright {
        text-align: center;
        font-size: 12px;
        color: #aaaaaa;
        opacity: 0.7;
        margin-bottom: 35px;
        cursor: pointer;

        .home-copyright-active:hover {
          text-align: center;
          font-size: 12px;
          opacity: 0.7;
          margin-bottom: 35px;
          color: #444444;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue